import { render, staticRenderFns } from "./AppHeaderV2ProductScoreHistogram.vue?vue&type=template&id=a80ecae4&scoped=true"
import script from "./AppHeaderV2ProductScoreHistogram.vue?vue&type=script&lang=js"
export * from "./AppHeaderV2ProductScoreHistogram.vue?vue&type=script&lang=js"
import style0 from "./AppHeaderV2ProductScoreHistogram.vue?vue&type=style&index=0&id=a80ecae4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a80ecae4",
  null
  
)

export default component.exports